module.exports = __webpack_public_path__ + "img/icon-burger.cc84e057.svg";